import { useEffect, useState, useContext, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import toastError from '../../toasts/toastError';

import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  Box,
  useTheme,
} from '@mui/material';

import { Can } from '../Can';
import { i18n } from '../../translate/i18n';
import api from '../../services/api';
import { AuthContext } from '../../context/Auth/AuthContext';
import ExcelJS from 'exceljs';
import { getStyled } from './styles';

const ContactImportWpModal = ({
  isOpen,
  handleClose,
  selectedTags,
  hideNum,
  userProfile,
}) => {
  const theme = useTheme();
  const classes = getStyled();

  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const [contactsToImport, setContactsToImport] = useState([]);

  const handleClosed = useCallback(() => {
    setContactsToImport([]);
    handleClose();
  }, [handleClose]);

  useEffect(() => {
    if (contactsToImport?.length) {
      contactsToImport.map(async (item, index) => {
        setTimeout(async () => {
          try {
            if (index >= contactsToImport?.length - 1) {
              setTimeout(() => {
                handleClosed();
              }, 15000);
            }
            await api.post(`/contactsImport`, {
              name: item.name,
              number: item.number.toString(),
              email: item.email,
            });
          } catch (err) {
            throw err.message;
          }
        }, 330 * index);
      });
    }
  }, [contactsToImport, handleClosed]);

  const handleOnExportContacts = async (model = false) => {
    const allDatas = [];

    let i = 1;
    if (!model) {
      while (i !== 0) {
        const { data } = await api.get('/contacts/', {
          params: {
            searchParam: '',
            pageNumber: i,
            contactTag: JSON.stringify(selectedTags),
          },
        });
        data.contacts.forEach((element) => {
          const tagsContact = element?.tags?.map((tag) => tag?.name).join(', ');
          const contactWithTags = { ...element, tags: tagsContact };
          allDatas.push(contactWithTags);
        });

        const pages = data?.count / 20;
        i++;
        if (i > pages) {
          i = 0;
        }
      }
    } else {
      allDatas.push({
        name: 'João',
        number: '5599999999999',
        email: '',
      });
    }

    const exportData = allDatas.map((e) => {
      return {
        name: e.name,
        number:
          hideNum && userProfile === 'user'
            ? e.isGroup
              ? e.number
              : e.number.slice(0, -6) + '**-**' + e.number.slice(-2)
            : e.number,
        email: e.email,
        tags: e.tags,
      };
    });

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Contatos');

    const headers = Object.keys(exportData[0] || {});
    worksheet.addRow(headers);

    exportData.forEach((item) => {
      const row = headers.map((header) => item[header]);
      worksheet.addRow(row);
    });

    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E0E0' },
    };

    worksheet.columns.forEach((column) => {
      column.width = 20;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = 'backup_contatos.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleimportContact = async () => {
    try {
      navigate('/contacts/import');
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <Dialog fullWidth open={isOpen} onClose={handleClosed}>
      <DialogTitle sx={theme.custom.dialogColor}>
        {i18n.t('Exportar / Importar contatos')}
      </DialogTitle>
      <div style={{ backgroundColor: theme.custom.colors.defaultBackground }}>
        <Box sx={{ padding: '0px 10px 10px' }}>
          <Can
            role={user.profile}
            perform='contacts-page:deleteContact'
            yes={() => (
              <div style={classes.multFieldLine}>
                <Button
                  fullWidth
                  size='small'
                  sx={theme.custom.editButton}
                  variant='outlined'
                  onClick={() => handleOnExportContacts(false)}
                >
                  {i18n.t('contactImportWpModal.title')}
                </Button>
              </div>
            )}
          />
          <div style={classes.multFieldLine}>
            <Button
              fullWidth
              size='small'
              sx={theme.custom.editButton}
              variant='outlined'
              onClick={() => handleOnExportContacts(true)}
            >
              {i18n.t('contactImportWpModal.buttons.downloadModel')}
            </Button>
          </div>
          <div style={classes.multFieldLine}>
            <Button
              fullWidth
              size='small'
              variant='outlined'
              sx={theme.custom.editButton}
              onClick={() => handleimportContact()}
            >
              {i18n.t('contactImportWpModal.buttons.import')}
            </Button>
          </div>
        </Box>
      </div>

      <DialogActions sx={theme.custom.dialogColor}>
        <Button
          variant='outlined'
          onClick={handleClose}
          sx={theme.custom.cancelButton}
        >
          {i18n.t('contactImportWpModal.buttons.closed')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactImportWpModal;
